import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur
        eaque sint ea error doloremque. Suscipit sed molestiae laboriosam
        aliquam vel commodi, consequuntur, asperiores maiores vero quae quo
        fugiat cumque facilis nihil accusamus sit iure nisi officia facere?
        Porro, culpa amet.
      </p>
    </section>
  );
};

export default About;
